export function areRouteParamsEqual(a, b) {
	return (
		!!(a && b) &&
		a.exhibitionID === b.exhibitionID &&
		((!a.tourID && !b.tourID) || a.tourID === b.tourID) &&
		a.articleID === b.articleID
	);
}
